import { Controller } from '@hotwired/stimulus'
import { camelCase } from 'lodash';

export default class extends Controller {
  static targets = [
    'form',
    'cardBucket',
    'cardBucketRoomNumber',
    'enableCardBucketRoomNumber',
    'cardBucketRefreshButton',
    'cashBucket',
    'cashBucketRoomNumber',
    'enableCashBucketRoomNumber',
    'cashBucketRefreshButton',
    'roomChargeBucket',
    'roomChargeBucketRoomNumber',
    'enableRoomChargeBucketRoomNumber',
    'roomChargeBucketRefreshButton',
    'cardBillingCode',
    'cashBillingCode',
    'roomChargeBillingCode',
    'cardBucketRadio',
    'cashBucketRadio',
    'roomChargeBucketRadio',
  ]

  connect() {
    this.enableCheckboxesEventListeners();
    this.enableRadioButtonEventListeners();
  }

  enableRadioButtonEventListeners() {
    const radioButtons = [
      this.cardBucketRadioTargets,
      this.cashBucketRadioTargets,
      this.roomChargeBucketRadioTargets
    ]

    radioButtons.forEach(radioButton => {
      radioButton.forEach(button => {
        button.addEventListener('click', _ => this.handleRadioButtonEvent(button))
      })
    })
  }

  handleRadioButtonEvent(radioButton) {
    let type = radioButton.name.split('_bucket_radio')[0] // e.g card, cash, room_charge
    let selectTarget = this[`${camelCase(type)}BillingCodeTarget`]

    if (radioButton.value === 'billing_payments') {
      selectTarget.disabled = false
      selectTarget.value = selectTarget.dataset.selectedValue
    } else {
      selectTarget.disabled = true
      selectTarget.value = ''
    }

    selectTarget.dispatchEvent(new Event('change'));
  }

  enableCheckboxesEventListeners() {
    const checkBoxes = [
      this.enableCardBucketRoomNumberTarget,
      this.enableCashBucketRoomNumberTarget,
      this.enableRoomChargeBucketRoomNumberTarget
    ]

    checkBoxes.forEach(checkBox => {
      checkBox.addEventListener('change', e => this.handleCheckBoxEvent(e, checkBox))
      this.enablePrefilledBucketRoomNumber(checkBox)
    })
  }

  enablePrefilledBucketRoomNumber(checkBox) {
    const bucketName = this.bucketNameFrom(checkBox.id)
    const bucketNameTarget = this[`${bucketName}Target`]
    const lookupInputTarget = this.lookupInputFrom(bucketName)
    const refreshButtonTarget = this.refreshButtonFrom(bucketName)

    if (lookupInputTarget.value !== '') {
      checkBox.checked = true
      bucketNameTarget.disabled = true
      lookupInputTarget.disabled = false
      refreshButtonTarget.disabled = false
    }
  }

  handleCheckBoxEvent(event, checkBox) {
    const bucketName = this.bucketNameFrom(checkBox.id)
    const bucketNameTarget = this[`${bucketName}Target`]
    const lookupInputTarget = this.lookupInputFrom(bucketName)
    const refreshButtonTarget = this.refreshButtonFrom(bucketName)

    if (event.target.checked) {
      bucketNameTarget.disabled = true
      lookupInputTarget.disabled = false
      refreshButtonTarget.disabled = false
    } else {
      bucketNameTarget.disabled = false
      lookupInputTarget.disabled = true
      refreshButtonTarget.disabled = true
    }
  }

  bucketNameFrom(checkBoxId) {
    return camelCase(checkBoxId.replace(/enable_|_room_number/g, ''))
  }

  lookupInputFrom(name) {
    return this[`${name}RoomNumberTarget`]
  }

  refreshButtonFrom(name) {
    return this[`${name}RefreshButtonTarget`]
  }
}
